
export enum SaveStatus {
    Saved = 'Saved',
    Unsaved = 'Unsaved'
}